module.exports = __webpack_public_path__ + "static/que_esperas-4a4a067b05149f52d5125d4db6d3f231.png";